import { Component, OnInit } from '@angular/core';
import { AdminService, MonitoringOverviewRow, ServiceEntry } from '../../core/services/admin.service';

@Component({
  selector: 'app-monitoring-overview',
  templateUrl: './monitoring-overview.component.html',
})
export class MonitoringOverviewComponent implements OnInit {
  rows: MonitoringOverviewRow[] = [];
  loading = true;
  error = '';
  expandedUserId: string | null = null;
  userServices: Record<string, ServiceEntry[]> = {};
  userServicesLoading: Record<string, boolean> = {};

  constructor(private readonly adminService: AdminService) {}

  ngOnInit(): void {
    this.adminService.getMonitoringOverview().subscribe({
      next: res => {
        this.rows    = res.overview;
        this.loading = false;
      },
      error: () => {
        this.error   = 'Failed to load monitoring overview.';
        this.loading = false;
      },
    });
  }

  toggleExpand(userId: string): void {
    if (this.expandedUserId === userId) {
      this.expandedUserId = null;
      return;
    }
    this.expandedUserId = userId;
    if (!this.userServices[userId]) {
      this.loadUserServices(userId);
    }
  }

  private loadUserServices(userId: string): void {
    this.userServicesLoading[userId] = true;
    this.adminService.getUserServiceEntries(userId).subscribe({
      next: res => {
        this.userServices[userId]         = res.entries;
        this.userServicesLoading[userId]  = false;
      },
      error: () => {
        this.userServicesLoading[userId] = false;
      },
    });
  }

  quotaBarClass(row: MonitoringOverviewRow): string {
    if (row.percentUsed >= 100) return 'bg-red-500';
    if (row.percentUsed >= 80)  return 'bg-amber-400';
    return 'bg-violet-500';
  }

  tierBadgeClass(tier: string): string {
    const map: Record<string, string> = {
      FREE:       'bg-zinc-100 text-zinc-600',
      PRO:        'bg-blue-100 text-blue-700',
      ENTERPRISE: 'bg-violet-100 text-violet-700',
    };
    return map[tier] ?? 'bg-zinc-100 text-zinc-600';
  }

  serviceTypeBadge(type: string): string {
    const map: Record<string, string> = {
      LAMBDA:         'bg-orange-50 text-orange-700 border-orange-200',
      GLUE:           'bg-sky-50 text-sky-700 border-sky-200',
      PIPELINE:       'bg-emerald-50 text-emerald-700 border-emerald-200',
      STEP_FUNCTIONS: 'bg-purple-50 text-purple-700 border-purple-200',
      ECS_SERVICE:    'bg-teal-50 text-teal-700 border-teal-200',
      RDS_INSTANCE:   'bg-orange-50 text-orange-700 border-orange-200',
    };
    return map[type] ?? 'bg-slate-50 text-slate-600 border-slate-200';
  }
}
